var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dp-calendar-container box-item",
      class: { "is-dp-detail": _vm.isDailyProblemDetail }
    },
    [
      _vm._l(_vm.calendar, function(month) {
        return _c("div", { key: month.month, staticClass: "month" }, [
          _c("h5", { staticClass: "cap" }, [_vm._v(_vm._s(month.month))]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dp-calendar" },
            [
              _vm._l(month.calendar, function(week, mIndex) {
                return [
                  _vm._l(week, function(item, wIndex) {
                    return [
                      item.slug
                        ? _c(
                            "router-link",
                            {
                              key: item.slug + "-" + mIndex + "-" + wIndex,
                              attrs: {
                                to: {
                                  name: "daily_problems_problem",
                                  params: { slug: item.slug }
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  class: [
                                    "day",
                                    {
                                      completed: item.completed,
                                      today: _vm.isToday(
                                        item.date,
                                        month.month
                                      ),
                                      current: _vm.isCurrent(item.slug)
                                    }
                                  ]
                                },
                                [_c("span", [_vm._v(_vm._s(item.date))])]
                              )
                            ]
                          )
                        : _c(
                            "span",
                            {
                              key: item.slug,
                              class: [
                                "day",
                                {
                                  completed: item.completed,
                                  today: _vm.isToday(item.date, month.month)
                                }
                              ]
                            },
                            [_c("span", [_vm._v(_vm._s(item.date))])]
                          )
                    ]
                  })
                ]
              })
            ],
            2
          )
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }